export const getUserCompanyId = () => {
  let internalData = sessionStorage.getItem('user');
  const user = internalData ? JSON.parse(internalData) : null;
  if (user) {
    return user.companyId;
  }
  return null;
};
